import { findIndex, isNumber, min } from 'lodash'

export const STORAGE_UNIT = {
  B: 'B',
  KB: 'KB',
  MB: 'MB',
  GB: 'GB',
  TB: 'TB'
}
Object.defineProperties(STORAGE_UNIT, {
  isValidUnit: {
    writable: false,
    enumerable: false,
    value: function (value) {
      return Object.keys(this).some((u) => u === value)
    }
  },
  getPowIndex: {
    writable: false,
    enumerable: false,
    value: function (unit) {
      if (this.isValidUnit(unit)) {
        return findIndex(Object.keys(this), (u) => u === unit)
      } else {
        // eslint-disable-next-line
        console.warn('unsupport unit', unit)
        return 0
      }
    }
  },
  min: {
    writable: false,
    enumerable: false,
    value: function (...units) {
      const indexArr = units.map((u) => this.getPowIndex(u))
      const minIndex = min(indexArr)
      return units[indexArr.indexOf(minIndex)]
    }
  }
})

export const toFixed = (floatValue, decimalBit = 2, removeTrailingZeros = false) => {
  let roundedValue = parseFloat(floatValue.toFixed(decimalBit))

  if (removeTrailingZeros) {
    roundedValue = roundedValue.toString()
    roundedValue = parseFloat(roundedValue) // Removes trailing zeros
  }

  return roundedValue
}

/**
 *
 * @param {{B?: number, KB?: number, MB?: number, GB?: number, TB?: number}} storage
 * @param {string} targetUnit
 * @description Convert storage to target unit
 * @returns {string}
 */
export function storageUnitConvert(storage, targetUnit = 'GB') {
  console.assert(STORAGE_UNIT.isValidUnit(targetUnit), 'unknow unit', targetUnit)
  const currentSTORAGE_UNIT = Object.keys(storage).find((u) => storage[u] >= 0)
  console.assert(currentSTORAGE_UNIT, 'invalid storage', storage)
  const [currentStorageValue, targetStorageValue] = [
    STORAGE_UNIT.getPowIndex(currentSTORAGE_UNIT),
    STORAGE_UNIT.getPowIndex(targetUnit)
  ]
  const storageValue = storage[currentSTORAGE_UNIT]
  const value = storageValue * Math.pow(1024, currentStorageValue - targetStorageValue)
  return toFixed(value, 2) + ' ' + targetUnit
}

/**
 *
 * @param {number} value
 * @param {STORAGE_UNIT} currentUnit
 * @description Auto convert storage to a appropriate unit, like 2048GB to 2TB
 * @returns {string}
 */
export function storageConvertToAppropriateUnit(value, currentUnit) {
  console.assert(isNumber(value) && value >= 0 && STORAGE_UNIT.isValidUnit(currentUnit))
  const appropriateUnit = Object.keys(STORAGE_UNIT).find((unit) => {
    const newVal = parseInt(storageUnitConvert({ [currentUnit]: value }, unit))
    return newVal > 0 && newVal < 1024
  })
  return storageUnitConvert({ [currentUnit]: value }, appropriateUnit || STORAGE_UNIT.TB)
}
